import { Component, OnDestroy, OnInit } from '@angular/core';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { UserService } from 'src/app/calvin-emr-shared/services/user.service';
import { PageComponent } from 'src/app/calvin-emr-shared/page/page.component';
import { PatientService } from 'src/app/calvin-emr-shared/services/patient.service';
import { Router, RouterLink } from '@angular/router';
import { SUCCESS } from 'src/app/global';
import { PATH_CREATE_PATIENT, PATH_PATIENTS } from '../patients.global';
import { ToastService } from 'src/app/calvin-emr-shared/services/toast.service';
import { DialogService } from 'primeng/dynamicdialog';
import { Store } from '@ngrx/store';
import { selectUser } from 'src/app/calvin-emr-shared/state/auth/auth.selector';
import { NgIf, NgFor } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { PatientTableComponent } from '../patient-table/patient-table.component';
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { COLLECTION_PATIENTS } from 'src/app/calvin-emr-shared/global';

@Component({
  selector: 'app-patient-list-page',
  templateUrl: './patient-list-page.component.html',
  styleUrls: ['./patient-list-page.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    NgIf,
    ButtonDirective,
    RouterLink,
    NgFor,
    CheckboxModule,
    FormsModule,
    PatientTableComponent,
    ConfirmationDialogComponent
  ],
})
export class PatientListPageComponent extends PageComponent implements OnInit, OnDestroy {
  /**
   * Array of all patients held by the current user.
   */
  patients: Patient[] = [];

  selectedPatients: Patient[] = [];

  // Used for importing patients
  importErrors: string[] = [];

  showImportPatientsDialog = false;
  showDeletePatientsDialog = false;
  confirmDeletePatients = false;

  /**
   * Path local constant to direct to "Create Patient" page.
   */
  createPatientPath = `/${PATH_PATIENTS}/${PATH_CREATE_PATIENT}`;

  constructor(
    store: Store,
    private router: Router,
    private userService: UserService,
    private patientService: PatientService,
    private dialogService: DialogService,
    private toastService: ToastService
  ) {
    super(store);

    // Get the user's patients each time the user's data changes.
    this.currentUserSub = store.select(selectUser).subscribe(() => {
      this.getPatients();
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Unsubscribes from the currentUser$ Observable.
   */
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.currentUserSub.unsubscribe();
  }

  /**
   * Get each patient in the user's patient list and add
   * resulting data to the "patients" array.
   */
  getPatients() {
    this.startLoading();
    this.patientService.getPatientsForUser(this.currentUser).subscribe((patients: Patient[]) => {
      this.patients = patients;
      this.stopLoading();
    });
  }

  openImportPatientsDialog() {
    this.showImportPatientsDialog = true;
  }

  /**
   * Open up the dialog to confirm deleting patients.
   */
  openDeletePatientsDialog() {
    this.showDeletePatientsDialog = true;
  }

  onCloseDeletePatientsDialog(didConfirm: boolean) {
    if (didConfirm) {
      this.deletePatients();
    } else {
      this.confirmDeletePatients = false;
    }
  }

  deletePatients() {
    this.startLoading();
    this.toastService.clear();
    this.selectedPatients.forEach((patient) => {
      this.userService.deletePatientIdFromAllUsers(patient.id);

      this.patientService.deletePatient(patient.id, COLLECTION_PATIENTS).subscribe(() => {
        this.patients = this.patients.filter((p) => p.id !== patient.id);
        this.toastService.addOne({
          severity: SUCCESS,
          summary: 'Success',
          detail: `Deleted patient ${patient.id}!`,
        });
        this.stopLoading();
        this.selectedPatients.pop();
      });
    });
  }

  get didSelectPatients(): boolean {
    return this.selectedPatients.length > 0;
  }
}
